import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  loadingPathway: {
    id: 'learner.pathway.loading',
    defaultMessage: 'Loading learning path',
    description: 'Spinner label while a pathway loads',
  },
  pathwayLoadError: {
    id: 'learner.pathway.loadError',
    defaultMessage: 'We could not load this learning path. Try again shortly.',
    description: 'Error state when a pathway fails to load',
  },
  progressLabel: {
    id: 'learner.pathway.progress',
    defaultMessage: '{percent}% complete',
    description: 'Pathway progress label',
  },
  backToLearning: {
    id: 'learner.pathway.backToLearning',
    defaultMessage: 'Back to my learning',
    description: 'Banner back button',
  },
  componentsLeft: {
    id: 'learner.pathway.componentsLeft',
    defaultMessage: '{count, plural, one {# item left} other {# items left}}',
    description: 'Banner meta: components remaining',
  },
  progressTitle: {
    id: 'learner.pathway.progressTitle',
    defaultMessage: 'Your progress',
    description: 'Progress card title',
  },
  continueLearning: {
    id: 'learner.pathway.continueLearning',
    defaultMessage: 'Continue learning',
    description: 'Continue button on progress card',
  },
  completedCount: {
    id: 'learner.pathway.completedCount',
    defaultMessage: '{completed} of {total} completed',
    description: 'Progress card completed count',
  },
  componentsTitle: {
    id: 'learner.pathway.componentsTitle',
    defaultMessage: 'Path content',
    description: 'Components card title',
  },
  backToPath: {
    id: 'learner.pathway.backToPath',
    defaultMessage: 'Back to learning path',
    description: 'Back button on the component view',
  },
  componentNotFound: {
    id: 'learner.pathway.componentNotFound',
    defaultMessage: 'This content could not be found.',
    description: 'Component view not-found message',
  },
  resume: {
    id: 'learner.pathway.resume',
    defaultMessage: 'Resume learning',
    description: 'Resume button label',
  },
  start: {
    id: 'learner.pathway.start',
    defaultMessage: 'Start learning',
    description: 'Start button label when nothing is in progress yet',
  },
  open: {
    id: 'learner.pathway.open',
    defaultMessage: 'Open',
    description: 'Open a component',
  },
  completed: {
    id: 'learner.pathway.completed',
    defaultMessage: 'Completed',
    description: 'Completed status badge',
  },
  inProgress: {
    id: 'learner.pathway.inProgress',
    defaultMessage: 'In progress',
    description: 'In-progress status badge',
  },
  locked: {
    id: 'learner.pathway.locked',
    defaultMessage: 'Locked',
    description: 'Locked status badge',
  },
  lockedHint: {
    id: 'learner.pathway.lockedHint',
    defaultMessage: 'Complete the earlier required course to unlock this.',
    description: 'Tooltip/hint on a locked component',
  },
  optional: {
    id: 'learner.pathway.optional',
    defaultMessage: 'Optional',
    description: 'Badge marking a non-mandatory component',
  },
  emptyCurriculum: {
    id: 'learner.pathway.emptyCurriculum',
    defaultMessage: 'This learning path has no courses yet.',
    description: 'Empty curriculum state',
  },
});

export default messages;
